import { inject, Signal } from '@angular/core';
import { CURRENT_TRIP } from '../services';

/**
 * Returns wether the current user is owner of the trip.
 * @returns {Signal<boolean>}
 * @requires TripService - Must be run in provider context.
 */
export function isTripOwner(): Signal<boolean> {
  return inject(CURRENT_TRIP).isOwner;
}

/**
 * Returns the id of the trip owner.
 */
export function getTripOwnerId(): string | undefined {
  const trip = inject(CURRENT_TRIP, { optional: true });
  return trip ? trip.ownerId() : undefined;
}
